var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'environments/environment';
import { DatePipe } from '@angular/common';
import { MatSnackBar, MatDialog } from '@angular/material';
import { CrearEmpresaDialogComponent } from './crear-empresa-dialog.component';
var LiquidacionesComponent = /** @class */ (function () {
    function LiquidacionesComponent(http, datePipe, snackBar, route, router, dialog) {
        this.http = http;
        this.datePipe = datePipe;
        this.snackBar = snackBar;
        this.route = route;
        this.router = router;
        this.dialog = dialog;
        // Campos editables del encabezado
        this.anio = new Date().getFullYear();
        this.anioHasta = new Date().getFullYear(); // Año hasta (para rango multi-año)
        this.desdeMonth = 1; // Mes desde (1-12)
        this.hastaMonth = 12; // Mes hasta (1-12)
        this.cuit = '';
        this.fechaLiquidacion = '';
        this.empresa = '';
        this.domicilio = '';
        this.empresaNoRegistrada = false;
        // Datos multi-año
        this.liquidacionesAnios = [];
        this.anioActualIndex = 0; // Índice del año que se está mostrando en pantalla
        // Lista de meses para los dropdowns
        this.meses = [
            { value: 1, label: '01 - ENE' },
            { value: 2, label: '02 - FEB' },
            { value: 3, label: '03 - MAR' },
            { value: 4, label: '04 - ABR' },
            { value: 5, label: '05 - MAY' },
            { value: 6, label: '06 - JUN' },
            { value: 7, label: '07 - JUL' },
            { value: 8, label: '08 - AGO' },
            { value: 9, label: '09 - SEP' },
            { value: 10, label: '10 - OCT' },
            { value: 11, label: '11 - NOV' },
            { value: 12, label: '12 - DIC' }
        ];
        // Porcentajes de cálculo
        this.porcentajesDisponibles = [];
        this.aporteSeleccionado = null; // Porcentaje de aporte seleccionado
        this.contribucionSeleccionada = null; // Porcentaje de contribución seleccionado
        this.porcentajeAporte = 0.0255; // 2.55% - Se obtiene de aporteSeleccionado
        this.porcentajeContribucion = 0.051; // 5.1% - Se obtiene de contribucionSeleccionada
        this.tasaInteres = 0.00246666666666667; // Tasa de interés diaria editable (7.4% anual / 365 días)
        // Configuración de vencimientos
        this.diasVencimiento = [];
        this.mapaVencimientos = new Map(); // terminacion -> dia
        // Modal de configuración
        this.modalConfiguracionAbierto = false;
        // Periodos (14 filas: ENE a DIC + 1°SAC + 2°SAC)
        this.periodos = [];
        // Totales
        this.totalRemuneracion = 0;
        this.totalImporteAPagar = 0;
        this.totalAporte = 0;
        this.totalContribucion = 0;
        this.totalDiferenciaPago = 0;
        this.totalIntereses = 0;
        this.totalAportesNoDepo = 0;
        this.totalSaldoDeudor = 0;
        this.totalActualizacion = 0;
        this.totalAdeudado = 0;
        this.observaciones = '';
        // Campos del resumen de deuda (segunda página)
        this.totalEnLetras = '';
        this.diasPlazo = 5;
        this.diasPlazoLetras = 'cinco';
        // Texto legal (cargado desde API, con fallback al texto original si falla)
        this.textoLegalActivo = true;
        this.textoLegalP1Pre = 'De acuerdo al incumplimiento debidamente comprobado, se procede a notificar bajo apercibimiento legal en los términos de la ley 24642, 23551 y Ley 23660 del monto deudor arriba consignado, el que deberá ser depositado a favor de U.R.G.A.R.A. dentro del plazo de ';
        this.textoLegalP1Post = ' días.';
        this.textoLegalP2Normal = 'En la determinación del mismo se ha tenido en cuenta los Decretos y Resoluciones insertas al pie de cada ítem y los Artículos 744, 776, 777 y concordantes del Código Civil, haciendo el Sindicato la más amplia y expresa reserva de derechos, incluido el de solicitar la aplicación de la Ley 23771 (Penal Tributaria). Déjese expresa constancia que la presente ';
        this.textoLegalP2Negrita = 'no implica en modo alguno el reconocimiento por otras deudas que pudieran detectarse por los mismos u otros periodos.';
        this.representanteNombre = '';
        this.representanteDomicilio = '';
        this.representanteDNI = '';
        this.representanteCargo = '';
        this.vencimientoPagoObligacion = '';
        // Estado
        this.loading = false;
        this.cargandoEmpresa = false;
        // Persistencia
        this.liquidacionId = null;
        this.guardando = false;
        this.logoBase64 = '';
        this.fechaLiquidacion = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    }
    LiquidacionesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.cargarPorcentajes();
        this.cargarVencimientos();
        this.inicializarPeriodos();
        // Detectar si se está editando una liquidación guardada
        this.route.queryParams.subscribe(function (params) {
            if (params['id']) {
                var id = parseInt(params['id']);
                // Solo cargar si es un ID diferente al actual (evita recarga innecesaria post-guardado)
                if (id && !isNaN(id) && id !== _this.liquidacionId) {
                    _this.cargarLiquidacionGuardada(id);
                }
            }
            else {
                // Si no hay id en queryParams, limpiar estado de edición
                _this.liquidacionId = null;
            }
        });
        // Pre-cargar logo como base64 para popup de impresion
        this.cargarLogoBase64();
        // Cargar texto legal configurable desde API
        this.cargarTextoLegal();
    };
    /**
     * Carga los porcentajes disponibles desde la API
     */
    LiquidacionesComponent.prototype.cargarPorcentajes = function () {
        var _this = this;
        console.log('[Liquidaciones] Cargando porcentajes desde:', environment.backendUrl + "/api/porcentajes");
        this.http.get(environment.backendUrl + "/api/porcentajes")
            .subscribe(function (data) {
            console.log('[Liquidaciones] Porcentajes recibidos:', data);
            _this.porcentajesDisponibles = data;
            // Seleccionar los primeros porcentajes de aporte y contribución por defecto
            var aportes = data.filter(function (p) { return p.tipo === 'aporte'; });
            var contribuciones = data.filter(function (p) { return p.tipo === 'contribucion'; });
            console.log('[Liquidaciones] Aportes encontrados:', aportes);
            console.log('[Liquidaciones] Contribuciones encontradas:', contribuciones);
            if (aportes.length > 0) {
                _this.aporteSeleccionado = aportes[0];
                _this.porcentajeAporte = aportes[0].porcentaje;
                console.log('[Liquidaciones] Aporte seleccionado:', _this.porcentajeAporte, '(', (_this.porcentajeAporte * 100).toFixed(2), '%)');
            }
            else {
                console.warn('[Liquidaciones] ⚠️ No se encontraron porcentajes de tipo "aporte" en la DB. Usando valor por defecto:', _this.porcentajeAporte);
            }
            if (contribuciones.length > 0) {
                _this.contribucionSeleccionada = contribuciones[0];
                _this.porcentajeContribucion = contribuciones[0].porcentaje;
                console.log('[Liquidaciones] Contribución seleccionada:', _this.porcentajeContribucion, '(', (_this.porcentajeContribucion * 100).toFixed(2), '%)');
            }
            else {
                console.warn('[Liquidaciones] ⚠️ No se encontraron porcentajes de tipo "contribucion" en la DB. Usando valor por defecto:', _this.porcentajeContribucion);
            }
        }, function (error) {
            console.error('[Liquidaciones] ✗ ERROR al cargar porcentajes:', error);
            _this.snackBar.open('Error al cargar porcentajes de la base de datos', 'Cerrar', {
                duration: 3000
            });
        });
    };
    /**
     * Carga la configuración de vencimientos desde la API
     */
    LiquidacionesComponent.prototype.cargarVencimientos = function () {
        var _this = this;
        console.log('[Liquidaciones] Cargando vencimientos desde:', environment.backendUrl + "/api/vencimientos");
        this.http.get(environment.backendUrl + "/api/vencimientos")
            .subscribe(function (data) {
            console.log('[Liquidaciones] Vencimientos recibidos:', data);
            _this.diasVencimiento = data;
            // Construir mapa de terminaciones -> día
            _this.mapaVencimientos.clear();
            data.forEach(function (dv) {
                dv.terminaciones.forEach(function (term) {
                    _this.mapaVencimientos.set(term, dv.dia);
                });
            });
            console.log('[Liquidaciones] Mapa de vencimientos construido:', _this.mapaVencimientos);
        }, function (error) {
            console.error('[Liquidaciones] ✗ ERROR al cargar vencimientos:', error);
            _this.snackBar.open('Error al cargar configuración de vencimientos', 'Cerrar', {
                duration: 3000
            });
            // Usar configuración por defecto si falla
            _this.mapaVencimientos.set(0, 9);
            _this.mapaVencimientos.set(1, 9);
            _this.mapaVencimientos.set(2, 9);
            _this.mapaVencimientos.set(3, 9);
            _this.mapaVencimientos.set(4, 12);
            _this.mapaVencimientos.set(5, 12);
            _this.mapaVencimientos.set(6, 12);
            _this.mapaVencimientos.set(7, 13);
            _this.mapaVencimientos.set(8, 13);
            _this.mapaVencimientos.set(9, 13);
        });
    };
    /**
     * Abre el modal de configuración de porcentajes
     */
    LiquidacionesComponent.prototype.abrirModalConfiguracion = function () {
        this.modalConfiguracionAbierto = true;
    };
    /**
     * Cierra el modal de configuración
     */
    LiquidacionesComponent.prototype.cerrarModalConfiguracion = function () {
        this.modalConfiguracionAbierto = false;
    };
    /**
     * Aplica los porcentajes seleccionados en el modal
     */
    LiquidacionesComponent.prototype.aplicarConfiguracionPorcentajes = function () {
        if (this.aporteSeleccionado) {
            this.porcentajeAporte = this.aporteSeleccionado.porcentaje;
        }
        if (this.contribucionSeleccionada) {
            this.porcentajeContribucion = this.contribucionSeleccionada.porcentaje;
        }
        // Recalcular si ya hay datos cargados
        if (this.periodos.length > 0 && this.periodos[0].remuneracionTotal > 0) {
            this.calcularValoresDerivados();
            this.calcularTotales();
        }
        this.cerrarModalConfiguracion();
        this.snackBar.open('Porcentajes aplicados correctamente', 'Cerrar', {
            duration: 2000
        });
    };
    /**
     * Filtra porcentajes por tipo
     */
    LiquidacionesComponent.prototype.getPorcentajesPorTipo = function (tipo) {
        return this.porcentajesDisponibles.filter(function (p) { return p.tipo === tipo; });
    };
    /**
     * Formatea un porcentaje para mostrar
     */
    LiquidacionesComponent.prototype.formatearPorcentaje = function (valor) {
        return (valor * 100).toFixed(2) + '%';
    };
    /**
     * Inicializa los 14 periodos vacíos
     */
    LiquidacionesComponent.prototype.inicializarPeriodos = function () {
        var _this = this;
        var todosMeses = [
            { nombre: 'ENE', mes: '01', mesNum: 1 },
            { nombre: 'FEB', mes: '02', mesNum: 2 },
            { nombre: 'MAR', mes: '03', mesNum: 3 },
            { nombre: 'ABR', mes: '04', mesNum: 4 },
            { nombre: 'MAY', mes: '05', mesNum: 5 },
            { nombre: 'JUN', mes: '06', mesNum: 6 },
            { nombre: '1°SAC', mes: '07', mesNum: 6, esSAC: true },
            { nombre: 'JUL', mes: '07', mesNum: 7 },
            { nombre: 'AGO', mes: '08', mesNum: 8 },
            { nombre: 'SEP', mes: '09', mesNum: 9 },
            { nombre: 'OCT', mes: '10', mesNum: 10 },
            { nombre: 'NOV', mes: '11', mesNum: 11 },
            { nombre: 'DIC', mes: '12', mesNum: 12 },
            { nombre: '2°SAC', mes: '01', mesNum: 12, esSAC: true } // SAC de diciembre se presenta en enero siguiente
        ];
        // Filtrar meses según el rango seleccionado
        var meses = todosMeses.filter(function (m) {
            // Si los años difieren, el filtro por mes no aplica (rango cross-year)
            if (_this.anio !== _this.anioHasta) {
                return true;
            }
            // Incluir 1°SAC si junio está en el rango
            if (m.nombre === '1°SAC') {
                return _this.desdeMonth <= 6 && _this.hastaMonth >= 6;
            }
            // Incluir 2°SAC si diciembre está en el rango
            if (m.nombre === '2°SAC') {
                return _this.desdeMonth <= 12 && _this.hastaMonth >= 12;
            }
            // Para meses normales, verificar si están en el rango
            return m.mesNum >= _this.desdeMonth && m.mesNum <= _this.hastaMonth;
        });
        var anioCorto = this.anio.toString().slice(-2);
        this.periodos = meses.map(function (m, index) {
            var periodoCode = anioCorto + "/" + m.mes;
            // Para 2°SAC, es enero del año siguiente
            if (m.nombre === '2°SAC') {
                var anioSig = (_this.anio + 1).toString().slice(-2);
                periodoCode = anioSig + "/01";
            }
            return {
                periodo: m.nombre,
                periodoCode: periodoCode,
                cantidadPersonal: 0,
                remuneracionTotal: 0,
                importeAPagar: 0,
                aporte: 0,
                contribucion: 0,
                detalleImporte: 0,
                detalleFecha: '',
                fechaVencimiento: _this.calcularFechaVencimiento(m.mes, m.nombre === '2°SAC' ? _this.anio + 1 : _this.anio),
                diasMora: 0,
                diferenciaPagoParcial: 0,
                interesesPagoFueraTermino: 0,
                aportesContrNoDepositadas: 0,
                saldoDeudor: 0,
                actualizacionIntereses: 0,
                totalAdeudadoPeriodo: 0
            };
        });
    };
    /**
     * Calcula la fecha de vencimiento según la terminación del CUIT
     * Usa la configuración de la base de datos y ajusta días no hábiles (sábados/domingos)
     */
    LiquidacionesComponent.prototype.calcularFechaVencimiento = function (mes, anio) {
        if (!this.cuit || this.cuit.length < 11)
            return '';
        // Obtener la última cifra del CUIT (dígito verificador)
        var ultimaCifra = parseInt(this.cuit.charAt(this.cuit.length - 1));
        // Buscar día de vencimiento en la configuración
        var diaVencimiento = this.mapaVencimientos.get(ultimaCifra);
        // Si no hay configuración cargada, usar valores por defecto
        if (diaVencimiento === undefined) {
            console.warn('[Liquidaciones] No se encontró configuración de vencimiento para terminación', ultimaCifra);
            if (ultimaCifra >= 0 && ultimaCifra <= 3) {
                diaVencimiento = 9;
            }
            else if (ultimaCifra >= 4 && ultimaCifra <= 6) {
                diaVencimiento = 12;
            }
            else {
                diaVencimiento = 13;
            }
        }
        // El vencimiento es del mes siguiente
        var mesVenc = parseInt(mes) + 1;
        var anioVenc = anio;
        if (mesVenc > 12) {
            mesVenc = 1;
            anioVenc++;
        }
        // Crear fecha de vencimiento
        var fechaVenc = new Date(anioVenc, mesVenc - 1, diaVencimiento);
        // Ajustar si cae en sábado o domingo
        fechaVenc = this.ajustarDiaHabil(fechaVenc);
        var dia = fechaVenc.getDate();
        var mesFinal = fechaVenc.getMonth() + 1;
        var anioFinal = fechaVenc.getFullYear();
        return dia + "/" + mesFinal + "/" + anioFinal;
    };
    /**
     * Ajusta una fecha si cae en sábado o domingo, moviéndola al siguiente día hábil (lunes)
     */
    LiquidacionesComponent.prototype.ajustarDiaHabil = function (fecha) {
        var diaSemana = fecha.getDay(); // 0=domingo, 6=sábado
        if (diaSemana === 6) {
            // Sábado → mover a lunes (+2 días)
            fecha.setDate(fecha.getDate() + 2);
        }
        else if (diaSemana === 0) {
            // Domingo → mover a lunes (+1 día)
            fecha.setDate(fecha.getDate() + 1);
        }
        return fecha;
    };
    /**
     * Busca datos de la empresa por CUIT y carga remuneraciones y transferencias
     * Usa el nuevo endpoint /api/liquidaciones/datos
     */
    LiquidacionesComponent.prototype.buscarEmpresa = function () {
        var _this = this;
        if (!this.cuit || this.cuit.length < 11) {
            return;
        }
        // Validar rango de meses (solo aplica cuando mismo año)
        if (this.anio === this.anioHasta && this.desdeMonth > this.hastaMonth) {
            this.snackBar.open('El mes "Desde" debe ser menor o igual al mes "Hasta"', 'Cerrar', { duration: 3000 });
            return;
        }
        this.cargandoEmpresa = true;
        this.loading = true;
        // Reinicializar periodos antes de cargar datos
        this.inicializarPeriodos();
        // Construir URL con rango de años
        var url;
        if (this.anioHasta > this.anio) {
            // Consulta multi-año
            url = environment.backendUrl + "/api/liquidaciones/datos?cuit=" + this.cuit + "&anioDesde=" + this.anio + "&anioHasta=" + this.anioHasta;
        }
        else {
            // Consulta de un solo año (backward compatible)
            url = environment.backendUrl + "/api/liquidaciones/datos?cuit=" + this.cuit + "&anio=" + this.anio;
        }
        this.http.get(url).subscribe(function (response) {
            // Cargar datos de empresa
            if (response.empresa) {
                var emp = response.empresa;
                _this.empresa = emp.Razon_Social || '';
                _this.domicilio = (emp.Calle || '') + " " + (emp.Puerta || '') + " - CP " + (emp.Codigo_Postal || '');
                _this.empresaNoRegistrada = false;
            }
            else {
                _this.empresaNoRegistrada = true;
                _this.snackBar.open('No se encontró empresa con ese CUIT', 'Cerrar', { duration: 3000 });
            }
            // Verificar si la respuesta es multi-año o un solo año
            if (response.anios && Array.isArray(response.anios)) {
                // Respuesta multi-año
                _this.procesarDatosMultiAnio(response.anios);
            }
            else {
                // Respuesta de un solo año (backward compatible)
                _this.inicializarPeriodos();
                // Recalcular fechas de vencimiento con el nuevo CUIT
                _this.actualizarFechasVencimiento();
                // Cargar datos de nóminas (remuneraciones)
                if (response.nominas && response.nominas.length > 0) {
                    _this.procesarNominasNuevo(response.nominas);
                }
                // Cargar datos de transferencias
                if (response.transferencias && response.transferencias.length > 0) {
                    _this.procesarTransferenciasNuevo(response.transferencias);
                }
                // Calcular todos los valores derivados
                _this.calcularValoresDerivados();
                _this.calcularTotales();
            }
            _this.cargandoEmpresa = false;
            _this.loading = false;
            _this.snackBar.open('Datos cargados correctamente', 'Cerrar', { duration: 3000 });
        }, function (error) {
            console.error('Error buscando datos:', error);
            _this.snackBar.open('Error al cargar datos', 'Cerrar', { duration: 3000 });
            _this.cargandoEmpresa = false;
            _this.loading = false;
        });
    };
    /**
     * Procesa los datos de nóminas del nuevo endpoint
     * El array periodos tiene 14 elementos: ENE(0), FEB(1), MAR(2), ABR(3), MAY(4), JUN(5),
     * 1°SAC(6), JUL(7), AGO(8), SEP(9), OCT(10), NOV(11), DIC(12), 2°SAC(13)
     */
    LiquidacionesComponent.prototype.procesarNominasNuevo = function (data) {
        var _this = this;
        // Mapeo de mes a índice en el array periodos (saltando 1°SAC en índice 6)
        var mesMap = {
            '01': 0, '02': 1, '03': 2, '04': 3, '05': 4, '06': 5,
            '07': 7, '08': 8, '09': 9, '10': 10, '11': 11, '12': 12
        };
        data.forEach(function (item) {
            var periodo = item.periodo; // formato YY/MM (ej: 15/01 para enero 2015)
            var mes = periodo.split('/')[1]; // El mes está en la segunda posición
            var index = mesMap[mes];
            if (index !== undefined && _this.periodos[index]) {
                _this.periodos[index].remuneracionTotal = parseFloat(item.remuneracion) || 0;
                _this.periodos[index].cantidadPersonal = parseInt(item.cant_empleados) || 0;
            }
        });
    };
    /**
     * Procesa los datos de transferencias del nuevo endpoint
     * El array periodos tiene 14 elementos: ENE(0), FEB(1), MAR(2), ABR(3), MAY(4), JUN(5),
     * 1°SAC(6), JUL(7), AGO(8), SEP(9), OCT(10), NOV(11), DIC(12), 2°SAC(13)
     */
    LiquidacionesComponent.prototype.procesarTransferenciasNuevo = function (data) {
        var _this = this;
        // Mapeo de mes a índice en el array periodos (saltando 1°SAC en índice 6)
        var mesMap = {
            '01': 0, '02': 1, '03': 2, '04': 3, '05': 4, '06': 5,
            '07': 7, '08': 8, '09': 9, '10': 10, '11': 11, '12': 12
        };
        // Agrupar transferencias por período (sumando todos los conceptos)
        var depositosPorPeriodo = {};
        data.forEach(function (item) {
            var periodo = item.periodo;
            if (!depositosPorPeriodo[periodo]) {
                depositosPorPeriodo[periodo] = { importe: 0, fecha: '', conceptos: [] };
            }
            depositosPorPeriodo[periodo].importe += parseFloat(item.importe) || 0;
            if (item.fecha) {
                depositosPorPeriodo[periodo].fecha = item.fecha;
            }
            if (item.codconc) {
                depositosPorPeriodo[periodo].conceptos.push(item.codconc);
            }
        });
        // Asignar a los períodos
        Object.keys(depositosPorPeriodo).forEach(function (periodo) {
            var mes = periodo.split('/')[1];
            var index = mesMap[mes];
            if (index !== undefined && _this.periodos[index]) {
                var deposito = depositosPorPeriodo[periodo];
                _this.periodos[index].detalleImporte = _this.r2(deposito.importe);
                _this.periodos[index].detalleFecha = deposito.fecha ?
                    _this.datePipe.transform(deposito.fecha, 'dd/MM/yyyy') : '';
                // Log para debugging - identificar conceptos
                console.log("[Liquidaciones] Per\u00EDodo " + periodo + ": conceptos [" + deposito.conceptos.join(', ') + "], importe total: $" + deposito.importe.toFixed(2));
            }
        });
    };
    /**
     * Procesa datos de múltiples años del endpoint multi-año
     * Crea un array de LiquidacionAnio con periodos calculados para cada año
     */
    LiquidacionesComponent.prototype.procesarDatosMultiAnio = function (anios) {
        var _this = this;
        this.liquidacionesAnios = [];
        this.anioActualIndex = 0; // Resetear a primer año
        anios.forEach(function (anioData) {
            // Inicializar periodos para este año
            var periodosAnio = [];
            var mesesLabel = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
            var anioCorto = anioData.anio.toString().slice(-2);
            // Crear los 14 períodos (12 meses + 2 SAC)
            for (var i = 0; i < 12; i++) {
                var mes = (i + 1).toString().padStart(2, '0');
                periodosAnio.push({
                    periodo: mesesLabel[i],
                    periodoCode: anioCorto + "/" + mes,
                    cantidadPersonal: 0,
                    remuneracionTotal: 0,
                    importeAPagar: 0,
                    aporte: 0,
                    contribucion: 0,
                    detalleImporte: 0,
                    detalleFecha: '',
                    fechaVencimiento: _this.calcularFechaVencimiento(mes, anioData.anio),
                    diasMora: 0,
                    diferenciaPagoParcial: 0,
                    interesesPagoFueraTermino: 0,
                    aportesContrNoDepositadas: 0,
                    saldoDeudor: 0,
                    actualizacionIntereses: 0,
                    totalAdeudadoPeriodo: 0
                });
                // Agregar 1°SAC después de JUN (índice 5)
                if (i === 5) {
                    periodosAnio.push({
                        periodo: '1°SAC',
                        periodoCode: anioCorto + "/SAC1",
                        cantidadPersonal: 0,
                        remuneracionTotal: 0,
                        importeAPagar: 0,
                        aporte: 0,
                        contribucion: 0,
                        detalleImporte: 0,
                        detalleFecha: '',
                        fechaVencimiento: _this.calcularFechaVencimiento('07', anioData.anio),
                        diasMora: 0,
                        diferenciaPagoParcial: 0,
                        interesesPagoFueraTermino: 0,
                        aportesContrNoDepositadas: 0,
                        saldoDeudor: 0,
                        actualizacionIntereses: 0,
                        totalAdeudadoPeriodo: 0
                    });
                }
            }
            // Agregar 2°SAC al final
            periodosAnio.push({
                periodo: '2°SAC',
                periodoCode: anioCorto + "/SAC2",
                cantidadPersonal: 0,
                remuneracionTotal: 0,
                importeAPagar: 0,
                aporte: 0,
                contribucion: 0,
                detalleImporte: 0,
                detalleFecha: '',
                fechaVencimiento: _this.calcularFechaVencimiento('01', anioData.anio + 1),
                diasMora: 0,
                diferenciaPagoParcial: 0,
                interesesPagoFueraTermino: 0,
                aportesContrNoDepositadas: 0,
                saldoDeudor: 0,
                actualizacionIntereses: 0,
                totalAdeudadoPeriodo: 0
            });
            // Procesar nóminas para este año
            if (anioData.nominas && anioData.nominas.length > 0) {
                _this.procesarNominasParaAnio(anioData.nominas, periodosAnio);
            }
            // Procesar transferencias para este año
            if (anioData.transferencias && anioData.transferencias.length > 0) {
                _this.procesarTransferenciasParaAnio(anioData.transferencias, periodosAnio);
            }
            // Calcular valores derivados para este año
            _this.calcularValoresDerivadosParaAnio(periodosAnio);
            // Filtrar períodos fuera del rango de meses para primer y último año
            var primerAnio = anioData.anio === _this.anio;
            var ultimoAnio = anioData.anio === _this.anioHasta;
            var periodosParaMostrar = periodosAnio;
            if (primerAnio || ultimoAnio) {
                var mesMin = primerAnio ? _this.desdeMonth : 1;
                var mesMax = ultimoAnio ? _this.hastaMonth : 12;
                periodosParaMostrar = periodosAnio.filter(function (p) {
                    if (p.periodo === '1°SAC') {
                        return mesMin <= 6 && mesMax >= 6;
                    }
                    if (p.periodo === '2°SAC') {
                        return mesMax >= 12;
                    }
                    var mes = parseInt(p.periodoCode.split('/')[1]);
                    return mes >= mesMin && mes <= mesMax;
                });
            }
            // Calcular totales para este año, solo sobre los períodos visibles y con deuda
            var periodosConDeuda = periodosParaMostrar.filter(function (p) { return p.totalAdeudadoPeriodo > 0; });
            var totales = _this.calcularTotalesParaAnio(periodosConDeuda);
            // Agregar año a la lista
            _this.liquidacionesAnios.push(__assign({ anio: anioData.anio, periodos: periodosParaMostrar }, totales));
        });
        // Filtrar años sin deuda: no mostrar en pantalla ni en impresión
        this.liquidacionesAnios = this.liquidacionesAnios.filter(function (a) { return a.totalAdeudado > 0; });
        console.log('[Liquidaciones] Datos multi-año procesados:', this.liquidacionesAnios.length, 'años con deuda');
    };
    /**
     * Procesa nóminas para un array específico de períodos
     */
    LiquidacionesComponent.prototype.procesarNominasParaAnio = function (data, periodos) {
        var mesMap = {
            '01': 0, '02': 1, '03': 2, '04': 3, '05': 4, '06': 5,
            '07': 7, '08': 8, '09': 9, '10': 10, '11': 11, '12': 12
        };
        data.forEach(function (item) {
            var periodo = item.periodo;
            var mes = periodo.split('/')[1];
            var index = mesMap[mes];
            if (index !== undefined && periodos[index]) {
                periodos[index].remuneracionTotal = parseFloat(item.remuneracion) || 0;
                periodos[index].cantidadPersonal = parseInt(item.cant_empleados) || 0;
            }
        });
    };
    /**
     * Procesa transferencias para un array específico de períodos
     */
    LiquidacionesComponent.prototype.procesarTransferenciasParaAnio = function (data, periodos) {
        var _this = this;
        var mesMap = {
            '01': 0, '02': 1, '03': 2, '04': 3, '05': 4, '06': 5,
            '07': 7, '08': 8, '09': 9, '10': 10, '11': 11, '12': 12
        };
        var depositosPorPeriodo = {};
        data.forEach(function (item) {
            var periodo = item.periodo;
            if (!depositosPorPeriodo[periodo]) {
                depositosPorPeriodo[periodo] = { importe: 0, fecha: '', conceptos: [] };
            }
            depositosPorPeriodo[periodo].importe += parseFloat(item.importe) || 0;
            if (item.fecha) {
                depositosPorPeriodo[periodo].fecha = item.fecha;
            }
            if (item.codconc) {
                depositosPorPeriodo[periodo].conceptos.push(item.codconc);
            }
        });
        Object.keys(depositosPorPeriodo).forEach(function (periodo) {
            var mes = periodo.split('/')[1];
            var index = mesMap[mes];
            if (index !== undefined && periodos[index]) {
                var deposito = depositosPorPeriodo[periodo];
                periodos[index].detalleImporte = _this.r2(deposito.importe);
                periodos[index].detalleFecha = deposito.fecha ?
                    _this.datePipe.transform(deposito.fecha, 'dd/MM/yyyy') : '';
            }
        });
    };
    /** Redondea a 2 decimales para igualar comportamiento de Excel */
    LiquidacionesComponent.prototype.r2 = function (v) {
        return Math.round(v * 100) / 100;
    };
    /**
     * Determina si un periodo tiene datos relevantes (no está vacío).
     * Se usa para ocultar filas vacías en pantalla y en la impresión.
     */
    LiquidacionesComponent.prototype.periodoTieneDatos = function (p) {
        return p.remuneracionTotal > 0 || p.cantidadPersonal > 0 ||
            p.detalleImporte > 0 || p.importeAPagar > 0 ||
            p.totalAdeudadoPeriodo > 0;
    };
    /**
     * Calcula el gran total de un campo sumando todos los años de liquidacionesAnios.
     */
    LiquidacionesComponent.prototype.getGrandTotal = function (campo) {
        return this.r2(this.liquidacionesAnios.reduce(function (sum, a) { return sum + (a[campo] || 0); }, 0));
    };
    /**
     * Calcula valores derivados para un array específico de períodos
     */
    LiquidacionesComponent.prototype.calcularValoresDerivadosParaAnio = function (periodos) {
        var _this = this;
        var fechaLiq = this.parseFecha(this.fechaLiquidacion);
        var tasa = this.tasaInteres || 0.00246666666666667;
        periodos.forEach(function (p) {
            // Aporte y Contribución
            p.aporte = _this.r2(p.remuneracionTotal * _this.porcentajeAporte);
            p.contribucion = _this.r2(p.remuneracionTotal * _this.porcentajeContribucion);
            p.importeAPagar = _this.r2(p.aporte + p.contribucion);
            // Aportes y contribuciones no depositadas (solo cuando NO hay deposito alguno)
            if (!p.detalleImporte && p.importeAPagar > 0) {
                p.aportesContrNoDepositadas = _this.r2(p.importeAPagar);
            }
            else {
                p.aportesContrNoDepositadas = 0;
            }
            // Diferencia de pago parcial (monto restante cuando hay deposito parcial)
            if (p.detalleImporte > 0 && p.detalleImporte < p.importeAPagar) {
                p.diferenciaPagoParcial = _this.r2(p.importeAPagar - p.detalleImporte);
            }
            else {
                p.diferenciaPagoParcial = 0;
            }
            // Días de mora
            p.diasMora = _this.calcularDiasMora(p, fechaLiq);
            // Intereses por pago fuera de termino (formula Excel confirmada 2026-04-28)
            // Sin deposito → 0 (los intereses van en actualizacionIntereses)
            // Pago parcial → diferencia x (fechaLiq-fechaVenc) x tasa + depositado x (fechaDeposito-fechaVenc) x tasa
            // Pago completo tardio → total x (fechaDeposito-fechaVenc) x tasa
            if (!p.detalleImporte) {
                p.interesesPagoFueraTermino = 0;
            }
            else {
                var fechaVencInt = _this.parseFecha(p.fechaVencimiento);
                var fechaDepInt = _this.parseFecha(p.detalleFecha);
                var diasDeposito = (fechaDepInt && fechaVencInt && fechaDepInt > fechaVencInt)
                    ? Math.ceil(Math.abs(fechaDepInt.getTime() - fechaVencInt.getTime()) / (1000 * 60 * 60 * 24))
                    : 0;
                if (_this.r2(p.diferenciaPagoParcial) > 0) {
                    var diasLiqInt = (fechaLiq && fechaVencInt && fechaLiq > fechaVencInt)
                        ? Math.ceil(Math.abs(fechaLiq.getTime() - fechaVencInt.getTime()) / (1000 * 60 * 60 * 24))
                        : 0;
                    p.interesesPagoFueraTermino = _this.r2(Math.max(0, p.diferenciaPagoParcial * diasLiqInt * tasa) +
                        Math.max(0, p.detalleImporte * diasDeposito * tasa));
                }
                else {
                    // Pago completo, aunque tardío: no se cobra interés (pedido de Nico, confirmado 2026-08-04)
                    p.interesesPagoFueraTermino = 0;
                }
            }
            p.saldoDeudor = _this.r2(p.aportesContrNoDepositadas + p.diferenciaPagoParcial + p.interesesPagoFueraTermino);
            if (p.diasMora > 0 && p.aportesContrNoDepositadas > 0) {
                p.actualizacionIntereses = _this.r2(p.aportesContrNoDepositadas * p.diasMora * tasa);
            }
            else {
                p.actualizacionIntereses = 0;
            }
            p.totalAdeudadoPeriodo = _this.r2(p.saldoDeudor + p.actualizacionIntereses);
        });
    };
    /**
     * Calcula totales para un array específico de períodos
     */
    LiquidacionesComponent.prototype.calcularTotalesParaAnio = function (periodos) {
        return {
            totalRemuneracion: this.r2(periodos.reduce(function (sum, p) { return sum + p.remuneracionTotal; }, 0)),
            totalImporteAPagar: this.r2(periodos.reduce(function (sum, p) { return sum + p.importeAPagar; }, 0)),
            totalAporte: this.r2(periodos.reduce(function (sum, p) { return sum + p.aporte; }, 0)),
            totalContribucion: this.r2(periodos.reduce(function (sum, p) { return sum + p.contribucion; }, 0)),
            totalDiferenciaPago: this.r2(periodos.reduce(function (sum, p) { return sum + p.diferenciaPagoParcial; }, 0)),
            totalIntereses: this.r2(periodos.reduce(function (sum, p) { return sum + p.interesesPagoFueraTermino; }, 0)),
            totalAportesNoDepo: this.r2(periodos.reduce(function (sum, p) { return sum + p.aportesContrNoDepositadas; }, 0)),
            totalSaldoDeudor: this.r2(periodos.reduce(function (sum, p) { return sum + p.saldoDeudor; }, 0)),
            totalActualizacion: this.r2(periodos.reduce(function (sum, p) { return sum + p.actualizacionIntereses; }, 0)),
            totalAdeudado: this.r2(periodos.reduce(function (sum, p) { return sum + p.totalAdeudadoPeriodo; }, 0))
        };
    };
    /**
     * Actualiza las fechas de vencimiento de todos los periodos
     */
    LiquidacionesComponent.prototype.actualizarFechasVencimiento = function () {
        var _this = this;
        this.periodos.forEach(function (p, index) {
            var meses = ['01', '02', '03', '04', '05', '06', '07', '07', '08', '09', '10', '11', '12', '01'];
            var anioBase = p.periodo === '2°SAC' ? _this.anio + 1 : _this.anio;
            p.fechaVencimiento = _this.calcularFechaVencimiento(meses[index], anioBase);
        });
    };
    /**
     * Busca los datos de liquidación para el CUIT y año seleccionados
     */
    LiquidacionesComponent.prototype.buscarDatos = function () {
        var _this = this;
        if (!this.cuit || !this.anio) {
            this.snackBar.open('Ingrese CUIT y Año', 'Cerrar', { duration: 3000 });
            return;
        }
        // Validar rango de meses (solo aplica cuando mismo año)
        if (this.anio === this.anioHasta && this.desdeMonth > this.hastaMonth) {
            this.snackBar.open('El mes "Desde" debe ser menor o igual al mes "Hasta"', 'Cerrar', { duration: 3000 });
            return;
        }
        // Buscar empresa si no está cargada
        if (!this.empresa) {
            this.buscarEmpresa();
        }
        this.loading = true;
        var anioDesdeCorto = this.anio.toString().slice(-2);
        var anioHastaCorto = this.anioHasta.toString().slice(-2);
        var perdes = anioDesdeCorto + "/" + this.desdeMonth.toString().padStart(2, '0');
        var perhas = anioHastaCorto + "/" + this.hastaMonth.toString().padStart(2, '0');
        // Reinicializar periodos
        this.inicializarPeriodos();
        // Buscar datos de nóminas (remuneraciones y cantidad de personal)
        var urlNominas = environment.backendUrl + "/api/reporte-deudas/periodos-impagos?cuit=" + this.cuit + "&perdes=" + perdes + "&perhas=" + perhas + "&pageSize=999";
        // Buscar datos de transferencias (depósitos)
        var urlTransferencias = environment.backendUrl + "/api/reporte-deudas/consultar?cuit=" + this.cuit + "&perdes=" + perdes + "&perhas=" + perhas + "&pageSize=999";
        // Ejecutar ambas consultas
        Promise.all([
            this.http.get(urlNominas).toPromise(),
            this.http.get(urlTransferencias).toPromise()
        ]).then(function (_a) {
            var nominasResp = _a[0], transferenciasResp = _a[1];
            // Procesar datos de nóminas
            if (nominasResp && nominasResp.data) {
                _this.procesarNominas(nominasResp.data);
            }
            // Procesar datos de transferencias
            if (transferenciasResp && transferenciasResp.data) {
                _this.procesarTransferencias(transferenciasResp.data);
            }
            // Calcular todos los valores derivados
            _this.calcularValoresDerivados();
            _this.calcularTotales();
            _this.loading = false;
            _this.snackBar.open('Datos cargados correctamente', 'Cerrar', { duration: 3000 });
        }).catch(function (error) {
            console.error('Error cargando datos:', error);
            _this.snackBar.open('Error al cargar datos', 'Cerrar', { duration: 3000 });
            _this.loading = false;
        });
    };
    /**
     * Procesa los datos de nóminas y los asigna a los periodos correspondientes
     */
    LiquidacionesComponent.prototype.procesarNominas = function (data) {
        var _this = this;
        var mesMap = {
            '01': 0, '02': 1, '03': 2, '04': 3, '05': 4, '06': 5,
            '07': 7, '08': 8, '09': 9, '10': 10, '11': 11, '12': 12
        };
        data.forEach(function (item) {
            var periodo = item.periodo; // formato YY/MM
            var mes = periodo.split('/')[1];
            var index = mesMap[mes];
            if (index !== undefined && _this.periodos[index]) {
                _this.periodos[index].remuneracionTotal = parseFloat(item.deuda_nomina) || 0;
                _this.periodos[index].cantidadPersonal = parseInt(item.cant_empleados) || 0;
            }
        });
    };
    /**
     * Procesa los datos de transferencias (depósitos)
     */
    LiquidacionesComponent.prototype.procesarTransferencias = function (data) {
        var _this = this;
        var mesMap = {
            '01': 0, '02': 1, '03': 2, '04': 3, '05': 4, '06': 5,
            '07': 7, '08': 8, '09': 9, '10': 10, '11': 11, '12': 12
        };
        // Agrupar depósitos por periodo
        var depositosPorPeriodo = {};
        data.forEach(function (item) {
            var periodo = item.periodo;
            if (!depositosPorPeriodo[periodo]) {
                depositosPorPeriodo[periodo] = { importe: 0, fecha: '' };
            }
            depositosPorPeriodo[periodo].importe += parseFloat(item.importe) || 0;
            if (item.fecrec) {
                depositosPorPeriodo[periodo].fecha = item.fecrec;
            }
        });
        // Asignar a los periodos
        Object.keys(depositosPorPeriodo).forEach(function (periodo) {
            var mes = periodo.split('/')[1];
            var index = mesMap[mes];
            if (index !== undefined && _this.periodos[index]) {
                _this.periodos[index].detalleImporte = _this.r2(depositosPorPeriodo[periodo].importe);
                _this.periodos[index].detalleFecha = depositosPorPeriodo[periodo].fecha ?
                    _this.datePipe.transform(depositosPorPeriodo[periodo].fecha, 'dd/MM/yyyy') : '';
            }
        });
    };
    /**
     * Calcula todos los valores derivados para cada periodo
     */
    LiquidacionesComponent.prototype.calcularValoresDerivados = function () {
        var _this = this;
        var fechaLiq = this.parseFecha(this.fechaLiquidacion);
        var tasa = this.tasaInteres || 0.00246666666666667;
        this.periodos.forEach(function (p) {
            // Aporte y Contribución
            p.aporte = _this.r2(p.remuneracionTotal * _this.porcentajeAporte);
            p.contribucion = _this.r2(p.remuneracionTotal * _this.porcentajeContribucion);
            p.importeAPagar = _this.r2(p.aporte + p.contribucion);
            // Aportes y contribuciones no depositadas (solo cuando NO hay deposito alguno)
            if (!p.detalleImporte && p.importeAPagar > 0) {
                p.aportesContrNoDepositadas = _this.r2(p.importeAPagar);
            }
            else {
                p.aportesContrNoDepositadas = 0;
            }
            // Diferencia de pago parcial (monto restante cuando hay deposito parcial)
            if (p.detalleImporte > 0 && p.detalleImporte < p.importeAPagar) {
                p.diferenciaPagoParcial = _this.r2(p.importeAPagar - p.detalleImporte);
            }
            else {
                p.diferenciaPagoParcial = 0;
            }
            // Días de mora
            p.diasMora = _this.calcularDiasMora(p, fechaLiq);
            // Intereses por pago fuera de termino (formula Excel confirmada 2026-04-28)
            // Sin deposito → 0 (los intereses van en actualizacionIntereses)
            // Pago parcial → diferencia x (fechaLiq-fechaVenc) x tasa + depositado x (fechaDeposito-fechaVenc) x tasa
            // Pago completo tardio → total x (fechaDeposito-fechaVenc) x tasa
            if (!p.detalleImporte) {
                p.interesesPagoFueraTermino = 0;
            }
            else {
                var fechaVencInt = _this.parseFecha(p.fechaVencimiento);
                var fechaDepInt = _this.parseFecha(p.detalleFecha);
                var diasDeposito = (fechaDepInt && fechaVencInt && fechaDepInt > fechaVencInt)
                    ? Math.ceil(Math.abs(fechaDepInt.getTime() - fechaVencInt.getTime()) / (1000 * 60 * 60 * 24))
                    : 0;
                if (_this.r2(p.diferenciaPagoParcial) > 0) {
                    var diasLiqInt = (fechaLiq && fechaVencInt && fechaLiq > fechaVencInt)
                        ? Math.ceil(Math.abs(fechaLiq.getTime() - fechaVencInt.getTime()) / (1000 * 60 * 60 * 24))
                        : 0;
                    p.interesesPagoFueraTermino = _this.r2(Math.max(0, p.diferenciaPagoParcial * diasLiqInt * tasa) +
                        Math.max(0, p.detalleImporte * diasDeposito * tasa));
                }
                else {
                    // Pago completo, aunque tardío: no se cobra interés (pedido de Nico, confirmado 2026-08-04)
                    p.interesesPagoFueraTermino = 0;
                }
            }
            p.saldoDeudor = _this.r2(p.aportesContrNoDepositadas + p.diferenciaPagoParcial + p.interesesPagoFueraTermino);
            if (p.diasMora > 0 && p.aportesContrNoDepositadas > 0) {
                p.actualizacionIntereses = _this.r2(p.aportesContrNoDepositadas * p.diasMora * tasa);
            }
            else {
                p.actualizacionIntereses = 0;
            }
            p.totalAdeudadoPeriodo = _this.r2(p.saldoDeudor + p.actualizacionIntereses);
        });
    };
    /**
     * Parsea una fecha en formato dd/MM/yyyy
     */
    LiquidacionesComponent.prototype.parseFecha = function (fechaStr) {
        if (!fechaStr)
            return null;
        var parts = fechaStr.split('/');
        if (parts.length !== 3)
            return null;
        return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
    };
    /**
     * Calcula los totales de todas las columnas
     */
    LiquidacionesComponent.prototype.calcularTotales = function () {
        var periodosConDeuda = this.periodos.filter(function (p) { return p.totalAdeudadoPeriodo > 0; });
        this.totalRemuneracion = this.r2(periodosConDeuda.reduce(function (sum, p) { return sum + p.remuneracionTotal; }, 0));
        this.totalImporteAPagar = this.r2(periodosConDeuda.reduce(function (sum, p) { return sum + p.importeAPagar; }, 0));
        this.totalAporte = this.r2(periodosConDeuda.reduce(function (sum, p) { return sum + p.aporte; }, 0));
        this.totalContribucion = this.r2(periodosConDeuda.reduce(function (sum, p) { return sum + p.contribucion; }, 0));
        this.totalDiferenciaPago = this.r2(periodosConDeuda.reduce(function (sum, p) { return sum + p.diferenciaPagoParcial; }, 0));
        this.totalIntereses = this.r2(periodosConDeuda.reduce(function (sum, p) { return sum + p.interesesPagoFueraTermino; }, 0));
        this.totalAportesNoDepo = this.r2(periodosConDeuda.reduce(function (sum, p) { return sum + p.aportesContrNoDepositadas; }, 0));
        this.totalSaldoDeudor = this.r2(periodosConDeuda.reduce(function (sum, p) { return sum + p.saldoDeudor; }, 0));
        this.totalActualizacion = this.r2(periodosConDeuda.reduce(function (sum, p) { return sum + p.actualizacionIntereses; }, 0));
        this.totalAdeudado = this.r2(periodosConDeuda.reduce(function (sum, p) { return sum + p.totalAdeudadoPeriodo; }, 0));
    };
    /**
     * Al cambiar el año, reinicializa los periodos
     */
    LiquidacionesComponent.prototype.onAnioChange = function () {
        this.inicializarPeriodos();
    };
    /**
     * Imprime el acta
     */
    LiquidacionesComponent.prototype.imprimir = function () {
        // Agregar clase especial para forzar landscape en Chrome/Edge
        var acta = document.getElementById('pagina-primera-acta');
        if (acta) {
            acta.style.width = '297mm';
            acta.style.height = '210mm';
        }
        // Imprimir
        window.print();
        // Restaurar estilos después de imprimir
        setTimeout(function () {
            if (acta) {
                acta.style.width = '';
                acta.style.height = '';
            }
        }, 1000);
    };
    LiquidacionesComponent.prototype.calcularDiasMora = function (p, fechaLiq) {
        if (!p.fechaVencimiento)
            return 0;
        var fechaVenc = this.parseFecha(p.fechaVencimiento);
        if (!fechaVenc)
            return 0;
        // Sin importe a pagar y sin depósito → no hay mora (ej: SAC vacío)
        if (p.importeAPagar === 0 && !p.detalleImporte)
            return 0;
        // Pago completo (depositado >= importeAPagar) con fecha → dias = fechaDeposito - fechaVenc
        if (p.detalleFecha && this.r2(p.detalleImporte) >= this.r2(p.importeAPagar) && p.importeAPagar > 0) {
            var fechaDeposito = this.parseFecha(p.detalleFecha);
            if (fechaDeposito && fechaDeposito > fechaVenc) {
                return Math.ceil(Math.abs(fechaDeposito.getTime() - fechaVenc.getTime()) / (1000 * 60 * 60 * 24));
            }
            return 0;
        }
        // Pago parcial o sin depósito → dias = fechaLiquidacion - fechaVenc
        if (fechaLiq && fechaLiq > fechaVenc) {
            return Math.ceil(Math.abs(fechaLiq.getTime() - fechaVenc.getTime()) / (1000 * 60 * 60 * 24));
        }
        return 0;
    };
    /**
     * Recalcula los valores de un periodo específico cuando se editan campos
     */
    LiquidacionesComponent.prototype.recalcularPeriodo = function (p) {
        var fechaLiq = this.parseFecha(this.fechaLiquidacion);
        var tasa = this.tasaInteres || 0.00246666666666667;
        // Aporte y Contribución
        p.aporte = this.r2(p.remuneracionTotal * this.porcentajeAporte);
        p.contribucion = this.r2(p.remuneracionTotal * this.porcentajeContribucion);
        p.importeAPagar = this.r2(p.aporte + p.contribucion);
        // Aportes y contribuciones no depositadas (solo cuando NO hay deposito alguno)
        if (!p.detalleImporte && p.importeAPagar > 0) {
            p.aportesContrNoDepositadas = this.r2(p.importeAPagar);
        }
        else {
            p.aportesContrNoDepositadas = 0;
        }
        // Diferencia de pago parcial (monto restante cuando hay deposito parcial)
        if (p.detalleImporte > 0 && p.detalleImporte < p.importeAPagar) {
            p.diferenciaPagoParcial = this.r2(p.importeAPagar - p.detalleImporte);
        }
        else {
            p.diferenciaPagoParcial = 0;
        }
        // Días de mora
        p.diasMora = this.calcularDiasMora(p, fechaLiq);
        // Intereses por pago fuera de termino (formula Excel confirmada 2026-04-28)
        // Sin deposito → 0 (los intereses van en actualizacionIntereses)
        // Pago parcial → diferencia x (fechaLiq-fechaVenc) x tasa + depositado x (fechaDeposito-fechaVenc) x tasa
        // Pago completo tardio → total x (fechaDeposito-fechaVenc) x tasa
        if (!p.detalleImporte) {
            p.interesesPagoFueraTermino = 0;
        }
        else {
            var fechaVencInt = this.parseFecha(p.fechaVencimiento);
            var fechaDepInt = this.parseFecha(p.detalleFecha);
            var diasDeposito = (fechaDepInt && fechaVencInt && fechaDepInt > fechaVencInt)
                ? Math.ceil(Math.abs(fechaDepInt.getTime() - fechaVencInt.getTime()) / (1000 * 60 * 60 * 24))
                : 0;
            if (this.r2(p.diferenciaPagoParcial) > 0) {
                var diasLiqInt = (fechaLiq && fechaVencInt && fechaLiq > fechaVencInt)
                    ? Math.ceil(Math.abs(fechaLiq.getTime() - fechaVencInt.getTime()) / (1000 * 60 * 60 * 24))
                    : 0;
                p.interesesPagoFueraTermino = this.r2(Math.max(0, p.diferenciaPagoParcial * diasLiqInt * tasa) +
                    Math.max(0, p.detalleImporte * diasDeposito * tasa));
            }
            else {
                // Pago completo, aunque tardío: no se cobra interés (pedido de Nico, confirmado 2026-08-04)
                p.interesesPagoFueraTermino = 0;
            }
        }
        p.saldoDeudor = this.r2(p.aportesContrNoDepositadas + p.diferenciaPagoParcial + p.interesesPagoFueraTermino);
        if (p.diasMora > 0 && p.aportesContrNoDepositadas > 0) {
            p.actualizacionIntereses = this.r2(p.aportesContrNoDepositadas * p.diasMora * tasa);
        }
        else {
            p.actualizacionIntereses = 0;
        }
        p.totalAdeudadoPeriodo = this.r2(p.saldoDeudor + p.actualizacionIntereses);
        // Recalcular totales generales
        if (this.liquidacionesAnios.length > 0) {
            var liqAnioParent = this.liquidacionesAnios.find(function (la) {
                return la.periodos.indexOf(p) >= 0;
            });
            if (liqAnioParent) {
                var periodosConDeuda = liqAnioParent.periodos.filter(function (pp) { return pp.totalAdeudadoPeriodo > 0; });
                var nuevosTotales = this.calcularTotalesParaAnio(periodosConDeuda);
                liqAnioParent.totalRemuneracion = nuevosTotales.totalRemuneracion;
                liqAnioParent.totalImporteAPagar = nuevosTotales.totalImporteAPagar;
                liqAnioParent.totalAporte = nuevosTotales.totalAporte;
                liqAnioParent.totalContribucion = nuevosTotales.totalContribucion;
                liqAnioParent.totalDiferenciaPago = nuevosTotales.totalDiferenciaPago;
                liqAnioParent.totalIntereses = nuevosTotales.totalIntereses;
                liqAnioParent.totalAportesNoDepo = nuevosTotales.totalAportesNoDepo;
                liqAnioParent.totalSaldoDeudor = nuevosTotales.totalSaldoDeudor;
                liqAnioParent.totalActualizacion = nuevosTotales.totalActualizacion;
                liqAnioParent.totalAdeudado = nuevosTotales.totalAdeudado;
            }
        }
        else {
            this.calcularTotales();
        }
    };
    LiquidacionesComponent.prototype.recalcularTodosLosPeriodos = function () {
        if (this.liquidacionesAnios.length > 0) {
            for (var i = 0; i < this.liquidacionesAnios.length; i++) {
                for (var j = 0; j < this.liquidacionesAnios[i].periodos.length; j++) {
                    this.recalcularPeriodo(this.liquidacionesAnios[i].periodos[j]);
                }
            }
        }
        else {
            for (var k = 0; k < this.periodos.length; k++) {
                this.recalcularPeriodo(this.periodos[k]);
            }
        }
    };
    /**
     * Formatea un número como moneda
     */
    LiquidacionesComponent.prototype.formatCurrency = function (value) {
        if (!value || value === 0)
            return '0,00';
        return value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    /**
     * Navega al año anterior en la vista multi-año
     */
    LiquidacionesComponent.prototype.navegarAnioAnterior = function () {
        if (this.anioActualIndex > 0) {
            this.anioActualIndex--;
        }
    };
    /**
     * Navega al año siguiente en la vista multi-año
     */
    LiquidacionesComponent.prototype.navegarAnioSiguiente = function () {
        if (this.anioActualIndex < this.liquidacionesAnios.length - 1) {
            this.anioActualIndex++;
        }
    };
    /**
     * Obtiene el año actual visible en la navegación
     */
    LiquidacionesComponent.prototype.obtenerAnioActual = function () {
        if (this.liquidacionesAnios.length > 0 && this.anioActualIndex < this.liquidacionesAnios.length) {
            return this.liquidacionesAnios[this.anioActualIndex];
        }
        return null;
    };
    /**
     * Carga una liquidación guardada desde la base de datos por ID
     */
    LiquidacionesComponent.prototype.cargarLiquidacionGuardada = function (id) {
        var _this = this;
        this.loading = true;
        this.http.get(environment.backendUrl + "/api/liquidaciones/guardada/" + id)
            .subscribe(function (data) {
            _this.liquidacionId = data.id;
            // Poblar cabecera
            _this.cuit = data.cuit;
            _this.empresa = data.empresa;
            _this.domicilio = data.domicilio;
            _this.fechaLiquidacion = data.fechaLiquidacion;
            _this.tasaInteres = data.tasaInteres;
            _this.porcentajeAporte = data.porcentajeAporte;
            _this.porcentajeContribucion = data.porcentajeContribucion;
            _this.anio = data.anioDesde;
            _this.anioHasta = data.anioHasta;
            _this.desdeMonth = data.mesDesde;
            _this.hastaMonth = data.mesHasta;
            _this.observaciones = data.observaciones;
            _this.representanteNombre = data.representanteNombre;
            _this.representanteDomicilio = data.representanteDomicilio;
            _this.representanteDNI = data.representanteDNI;
            _this.representanteCargo = data.representanteCargo;
            _this.diasPlazo = data.diasPlazo;
            _this.diasPlazoLetras = data.diasPlazoLetras;
            _this.vencimientoPagoObligacion = data.vencimientoPagoObligacion;
            _this.totalEnLetras = data.totalEnLetras;
            // Poblar datos multi-año directamente desde el snapshot
            _this.liquidacionesAnios = data.liquidacionesAnios || [];
            _this.anioActualIndex = 0;
            // Si es single-year, también poblar los totales del componente
            if (_this.liquidacionesAnios.length === 1) {
                var liq = _this.liquidacionesAnios[0];
                _this.totalRemuneracion = liq.totalRemuneracion || 0;
                _this.totalImporteAPagar = liq.totalImporteAPagar || 0;
                _this.totalAporte = liq.totalAporte || 0;
                _this.totalContribucion = liq.totalContribucion || 0;
                _this.totalDiferenciaPago = liq.totalDiferenciaPago || 0;
                _this.totalIntereses = liq.totalIntereses || 0;
                _this.totalAportesNoDepo = liq.totalAportesNoDepo || 0;
                _this.totalSaldoDeudor = liq.totalSaldoDeudor || 0;
                _this.totalActualizacion = liq.totalActualizacion || 0;
                _this.totalAdeudado = liq.totalAdeudado || 0;
            }
            _this.recalcularTodosLosPeriodos();
            _this.loading = false;
            _this.snackBar.open("Liquidaci\u00F3n #" + id + " cargada correctamente", 'Cerrar', { duration: 3000 });
        }, function (error) {
            console.error('Error cargando liquidación guardada:', error);
            _this.snackBar.open('Error al cargar la liquidación', 'Cerrar', { duration: 3000 });
            _this.loading = false;
        });
    };
    /**
     * Guarda o actualiza la liquidación actual en la base de datos
     */
    LiquidacionesComponent.prototype.guardarLiquidacion = function () {
        var _this = this;
        if (!this.cuit || !this.empresa) {
            this.snackBar.open('Debe cargar una empresa antes de guardar', 'Cerrar', { duration: 3000 });
            return;
        }
        this.guardando = true;
        var payload = this.construirPayload();
        var usuario = localStorage.getItem('usuario') || '';
        if (this.liquidacionId) {
            // Actualizar existente
            payload['updatedBy'] = usuario;
            this.http.put(environment.backendUrl + "/api/liquidaciones/guardada/" + this.liquidacionId, payload)
                .subscribe(function (data) {
                _this.guardando = false;
                _this.snackBar.open("Liquidaci\u00F3n #" + _this.liquidacionId + " actualizada correctamente", 'Cerrar', { duration: 3000 });
            }, function (error) {
                console.error('Error actualizando liquidación:', error);
                _this.snackBar.open('Error al actualizar la liquidación', 'Cerrar', { duration: 3000 });
                _this.guardando = false;
            });
        }
        else {
            // Crear nueva
            payload['createdBy'] = usuario;
            payload['updatedBy'] = usuario;
            this.http.post(environment.backendUrl + "/api/liquidaciones/guardar", payload)
                .subscribe(function (data) {
                _this.liquidacionId = data.id;
                _this.guardando = false;
                _this.snackBar.open("Liquidaci\u00F3n guardada con ID #" + data.id, 'Cerrar', { duration: 3000 });
                // Actualizar URL sin recargar
                _this.router.navigate([], {
                    relativeTo: _this.route,
                    queryParams: { id: data.id },
                    queryParamsHandling: 'merge'
                });
            }, function (error) {
                console.error('Error guardando liquidación:', error);
                _this.snackBar.open('Error al guardar la liquidación', 'Cerrar', { duration: 3000 });
                _this.guardando = false;
            });
        }
    };
    /**
     * Construye el payload JSON para guardar/actualizar
     * Normaliza a formato multi-year siempre
     */
    LiquidacionesComponent.prototype.construirPayload = function () {
        var aniosData;
        if (this.liquidacionesAnios.length > 0) {
            // Modo multi-año: usar directamente
            aniosData = this.liquidacionesAnios.map(function (liqAnio) { return ({
                anio: liqAnio.anio,
                periodos: liqAnio.periodos,
                totalRemuneracion: liqAnio.totalRemuneracion,
                totalImporteAPagar: liqAnio.totalImporteAPagar,
                totalAporte: liqAnio.totalAporte,
                totalContribucion: liqAnio.totalContribucion,
                totalDiferenciaPago: liqAnio.totalDiferenciaPago,
                totalIntereses: liqAnio.totalIntereses,
                totalAportesNoDepo: liqAnio.totalAportesNoDepo,
                totalSaldoDeudor: liqAnio.totalSaldoDeudor,
                totalActualizacion: liqAnio.totalActualizacion,
                totalAdeudado: liqAnio.totalAdeudado
            }); });
        }
        else {
            // Modo single-year: envolver periodos en un array de un elemento
            aniosData = [{
                    anio: this.anio,
                    periodos: this.periodos,
                    totalRemuneracion: this.totalRemuneracion,
                    totalImporteAPagar: this.totalImporteAPagar,
                    totalAporte: this.totalAporte,
                    totalContribucion: this.totalContribucion,
                    totalDiferenciaPago: this.totalDiferenciaPago,
                    totalIntereses: this.totalIntereses,
                    totalAportesNoDepo: this.totalAportesNoDepo,
                    totalSaldoDeudor: this.totalSaldoDeudor,
                    totalActualizacion: this.totalActualizacion,
                    totalAdeudado: this.totalAdeudado
                }];
        }
        return {
            cuit: this.cuit,
            empresa: this.empresa,
            domicilio: this.domicilio,
            fechaLiquidacion: this.fechaLiquidacion,
            tasaInteres: this.tasaInteres,
            porcentajeAporte: this.porcentajeAporte,
            porcentajeContribucion: this.porcentajeContribucion,
            anioDesde: this.anio,
            anioHasta: this.anioHasta,
            mesDesde: this.desdeMonth,
            mesHasta: this.hastaMonth,
            observaciones: this.observaciones,
            representanteNombre: this.representanteNombre,
            representanteDomicilio: this.representanteDomicilio,
            representanteDNI: this.representanteDNI,
            representanteCargo: this.representanteCargo,
            diasPlazo: this.diasPlazo,
            diasPlazoLetras: this.diasPlazoLetras,
            vencimientoPagoObligacion: this.vencimientoPagoObligacion,
            totalEnLetras: this.totalEnLetras,
            liquidacionesAnios: aniosData
        };
    };
    /**
     * Resetea el estado y navega a una liquidación nueva
     */
    LiquidacionesComponent.prototype.nuevaLiquidacion = function () {
        this.liquidacionId = null;
        this.cuit = '';
        this.empresa = '';
        this.domicilio = '';
        this.empresaNoRegistrada = false;
        this.fechaLiquidacion = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
        this.tasaInteres = 0.00246666666666667;
        this.observaciones = '';
        this.totalEnLetras = '';
        this.representanteNombre = '';
        this.representanteDomicilio = '';
        this.representanteDNI = '';
        this.representanteCargo = '';
        this.diasPlazo = 5;
        this.diasPlazoLetras = 'cinco';
        this.vencimientoPagoObligacion = '';
        this.liquidacionesAnios = [];
        this.anioActualIndex = 0;
        this.anio = new Date().getFullYear();
        this.anioHasta = new Date().getFullYear();
        this.desdeMonth = 1;
        this.hastaMonth = 12;
        this.inicializarPeriodos();
        this.totalRemuneracion = 0;
        this.totalImporteAPagar = 0;
        this.totalAporte = 0;
        this.totalContribucion = 0;
        this.totalDiferenciaPago = 0;
        this.totalIntereses = 0;
        this.totalAportesNoDepo = 0;
        this.totalSaldoDeudor = 0;
        this.totalActualizacion = 0;
        this.totalAdeudado = 0;
        this.router.navigate(['/liquidaciones']);
    };
    // ========================================
    // PDF Popup Export (Patron 2)
    // ========================================
    /**
     * Pre-carga el logo como base64 para uso en popups de impresion
     */
    LiquidacionesComponent.prototype.cargarLogoBase64 = function () {
        var self = this;
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                self.logoBase64 = reader.result;
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.onerror = function () {
            console.warn('[Liquidaciones] No se pudo cargar el logo en base64');
        };
        xhr.open('GET', 'assets/img/osrga.jpeg');
        xhr.responseType = 'blob';
        xhr.send();
    };
    LiquidacionesComponent.prototype.cargarTextoLegal = function () {
        var _this = this;
        this.http.get(environment.backendUrl + "/api/texto-legal")
            .subscribe(function (data) {
            if (data['texto_legal_p1_pre']) {
                _this.textoLegalP1Pre = data['texto_legal_p1_pre'];
            }
            if (data['texto_legal_p1_post']) {
                _this.textoLegalP1Post = data['texto_legal_p1_post'];
            }
            if (data['texto_legal_p2_normal']) {
                _this.textoLegalP2Normal = data['texto_legal_p2_normal'];
            }
            if (data['texto_legal_p2_negrita']) {
                _this.textoLegalP2Negrita = data['texto_legal_p2_negrita'];
            }
            _this.textoLegalActivo = data['texto_legal_activo'] !== '0';
        }, function (error) {
            console.warn('[Liquidaciones] No se pudo cargar texto legal desde API. Se usan valores por defecto.', error);
        });
    };
    /**
     * Construye el CSS completo para el popup de impresion.
     * Usa CSS named pages para mezclar landscape (tabla) con portrait (resumen).
     */
    LiquidacionesComponent.prototype.construirCssPopup = function () {
        return '@page tabla-page { size: A4 landscape; margin: 0; }\n'
            + '@page resumen-page { size: legal portrait; margin: 0; }\n'
            + '.page-tabla { page: tabla-page; page-break-after: always; padding: 5mm; }\n'
            + '.page-resumen { page: resumen-page; page-break-after: always; padding: 10mm; }\n'
            + 'body { font-family: Arial, sans-serif; margin: 0; padding: 0; }\n'
            + 'table { width: 100%; border-collapse: collapse; }\n'
            + '.tabla-liq { font-size: 10px; }\n'
            + '.tabla-liq th, .tabla-liq td { border: 1px solid #999; padding: 3px 4px; }\n'
            + '.tabla-liq thead tr { background-color: #e8e8e8; font-weight: bold; }\n'
            + '.tabla-liq tfoot tr { background-color: #e8e8e8; font-weight: bold; }\n'
            + '.money { text-align: right; font-family: "Courier New", monospace; border: 1px solid #999; padding: 3px 4px; }\n'
            + '.tabla-enc td { border: 1px solid #999; padding: 4px 5px; vertical-align: top; }\n'
            + '.resumen-content { max-width: 700px; margin: 0 auto; font-size: 11px; }\n'
            + '.resumen-content table td { padding: 4px; }\n'
            + '.resumen-montos td { border: 1px solid #999; padding: 6px 10px; }\n'
            + '.resumen-montos .total-row { background-color: #e8e8e8; font-weight: bold; }\n'
            + '.firmas-container { display: flex; justify-content: space-between; margin-top: 40px; }\n'
            + '.firma-block { width: 30%; text-align: center; }\n'
            + '.firma-line { border-top: 1px solid #000; margin-bottom: 5px; }\n'
            + '.obs-box { border: 1px solid #999; padding: 5px; margin-top: 5px; font-size: 11px; min-height: 30px; }\n'
            + '.year-separator td { background-color: #d0d0d0; font-weight: bold; font-size: 12px; text-align: center; border: 1px solid #999; padding: 3px; }\n'
            + 'h4 { text-align: center; margin: 0 0 5px 0; }\n'
            + '.logo-img { max-width: 70px; max-height: 70px; }\n'
            + '@media print {\n'
            + '  html, body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }\n'
            + '}\n';
    };
    /**
     * Construye el HTML de la pagina landscape (tabla del acta) para un anio
     */
    LiquidacionesComponent.prototype.construirTablaAnioHtml = function (liqAnio, logoTag) {
        var html = '<div class="page-tabla">';
        // Titulo
        html += '<h4>ACTA DE INTIMACION DE PAGO:</h4>';
        // Encabezado institucional (3 filas)
        html += '<table class="tabla-enc">';
        html += '<tr>';
        html += '<td rowspan="3" style="width:80px;text-align:center;vertical-align:middle;">' + logoTag + '</td>';
        html += '<td style="text-align:center;font-weight:bold;">ANALISIS DE DEUDA<br>LEY 23.660</td>';
        html += '<td style="text-align:center;font-weight:bold;">PERIODO A VERIFICAR DE OBRA SOCIAL: 10 A&#209;OS</td>';
        html += '</tr>';
        html += '<tr>';
        html += '<td><strong>A&#209;O</strong><br>' + liqAnio.anio + '</td>';
        html += '<td><strong>CUIT N&#176;</strong> ' + (this.cuit || '-') + ' &nbsp;&nbsp;&nbsp; <strong>FECHA LIQUIDACION:</strong> ' + (this.fechaLiquidacion || '') + '</td>';
        html += '</tr>';
        html += '<tr>';
        html += '<td><strong>EMPRESA</strong><br>' + (this.empresa || '') + '</td>';
        html += '<td><strong>DOMICILIO:</strong><br>' + (this.domicilio || '') + '</td>';
        html += '</tr>';
        html += '</table>';
        // Tabla 16 columnas
        html += '<table class="tabla-liq">';
        html += '<thead>';
        html += '<tr>';
        html += '<th rowspan="2">Periodo</th>';
        html += '<th rowspan="2">Cant.<br>Pers.</th>';
        html += '<th rowspan="2">REMUN.<br>TOTAL</th>';
        html += '<th rowspan="2">Imp.a<br>Pagar</th>';
        html += '<th rowspan="2">Aporte</th>';
        html += '<th rowspan="2">Contrib.</th>';
        html += '<th colspan="2" style="text-align:center;">Dep.Importes</th>';
        html += '<th rowspan="2">F.Venc.</th>';
        html += '<th rowspan="2">D.Mora</th>';
        html += '<th rowspan="2">DIF.PAGO</th>';
        html += '<th rowspan="2">INT.F.<br>TERM.</th>';
        html += '<th rowspan="2">AP.C.NO<br>DEP.</th>';
        html += '<th rowspan="2">SALDO<br>DEUD.</th>';
        html += '<th rowspan="2">ACT.<br>INT.</th>';
        html += '<th rowspan="2">TOTAL<br>ADEUD.</th>';
        html += '</tr>';
        html += '<tr>';
        html += '<th>IMPORTE</th>';
        html += '<th>FECHA</th>';
        html += '</tr>';
        html += '</thead>';
        html += '<tbody>';
        for (var i = 0; i < liqAnio.periodos.length; i++) {
            var p = liqAnio.periodos[i];
            if (p.totalAdeudadoPeriodo <= 0) {
                continue;
            }
            html += '<tr>';
            html += '<td style="text-align:center;">' + p.periodo + '</td>';
            html += '<td style="text-align:center;">' + (p.cantidadPersonal || '') + '</td>';
            html += '<td class="money">' + this.formatCurrency(p.remuneracionTotal) + '</td>';
            html += '<td class="money">' + this.formatCurrency(p.importeAPagar) + '</td>';
            html += '<td class="money">' + this.formatCurrency(p.aporte) + '</td>';
            html += '<td class="money">' + this.formatCurrency(p.contribucion) + '</td>';
            html += '<td class="money">' + this.formatCurrency(p.detalleImporte) + '</td>';
            html += '<td style="border:1px solid #999;padding:3px 4px;text-align:center;font-size:9px;">' + (p.detalleFecha || '') + '</td>';
            html += '<td style="border:1px solid #999;padding:3px 4px;text-align:center;font-size:9px;">' + (p.fechaVencimiento || '') + '</td>';
            html += '<td style="border:1px solid #999;padding:3px 4px;text-align:center;">' + (p.diasMora || '') + '</td>';
            html += '<td class="money">' + this.formatCurrency(p.diferenciaPagoParcial) + '</td>';
            html += '<td class="money">' + this.formatCurrency(p.interesesPagoFueraTermino) + '</td>';
            html += '<td class="money">' + this.formatCurrency(p.aportesContrNoDepositadas) + '</td>';
            html += '<td class="money">' + this.formatCurrency(p.saldoDeudor) + '</td>';
            html += '<td class="money">' + this.formatCurrency(p.actualizacionIntereses) + '</td>';
            html += '<td class="money" style="font-weight:bold;">' + this.formatCurrency(p.totalAdeudadoPeriodo) + '</td>';
            html += '</tr>';
        }
        html += '</tbody>';
        html += '<tfoot>';
        html += '<tr>';
        html += '<td style="font-weight:bold;">TOTAL</td>';
        html += '<td></td>';
        html += '<td class="money">' + this.formatCurrency(liqAnio.totalRemuneracion) + '</td>';
        html += '<td class="money">' + this.formatCurrency(liqAnio.totalImporteAPagar) + '</td>';
        html += '<td class="money"></td>';
        html += '<td class="money"></td>';
        html += '<td class="money"></td>';
        html += '<td style="border:1px solid #999;padding:2px 3px;"></td>';
        html += '<td style="border:1px solid #999;padding:2px 3px;"></td>';
        html += '<td style="border:1px solid #999;padding:2px 3px;"></td>';
        html += '<td class="money">' + this.formatCurrency(liqAnio.totalDiferenciaPago) + '</td>';
        html += '<td class="money">' + this.formatCurrency(liqAnio.totalIntereses) + '</td>';
        html += '<td class="money">' + this.formatCurrency(liqAnio.totalAportesNoDepo) + '</td>';
        html += '<td class="money">' + this.formatCurrency(liqAnio.totalSaldoDeudor) + '</td>';
        html += '<td class="money">' + this.formatCurrency(liqAnio.totalActualizacion) + '</td>';
        html += '<td class="money" style="font-weight:bold;">' + this.formatCurrency(liqAnio.totalAdeudado) + '</td>';
        html += '</tr>';
        html += '</tfoot>';
        html += '</table>';
        // Observaciones
        html += '<div class="obs-box">';
        html += '<strong>OBSERVACIONES:</strong> ' + (this.observaciones || '');
        html += '</div>';
        // Firma
        html += '<div style="text-align:center;margin-top:15px;">';
        html += '<div style="width:200px;border-top:1px solid #000;margin:0 auto;"></div>';
        html += '<div style="font-size:9px;">FIRMA Y ACLARACION DEL INSPECTOR</div>';
        html += '</div>';
        html += '</div>'; // Fin page-tabla
        return html;
    };
    /**
     * Construye UNA sola acta landscape con todos los anios en una tabla continua.
     * Cada anio se separa con una fila "AÑO XXXX", seguida de sus 13 periodos y un subtotal.
     * Al final se muestra un TOTAL GENERAL, observaciones y firma.
     */
    LiquidacionesComponent.prototype.construirTablaUnificadaHtml = function (aniosData, logoTag) {
        var html = '<div class="page-tabla">';
        // Determinar texto de anios para el encabezado
        var anioTexto;
        if (aniosData.length === 1) {
            anioTexto = '' + aniosData[0].anio;
        }
        else {
            anioTexto = aniosData[0].anio + ' - ' + aniosData[aniosData.length - 1].anio;
        }
        // Titulo
        html += '<h4>ACTA DE INTIMACION DE PAGO:</h4>';
        // Encabezado institucional (3 filas)
        html += '<table class="tabla-enc">';
        html += '<tr>';
        html += '<td rowspan="3" style="width:80px;text-align:center;vertical-align:middle;">' + logoTag + '</td>';
        html += '<td style="text-align:center;font-weight:bold;">ANALISIS DE DEUDA<br>LEY 23.660</td>';
        html += '<td style="text-align:center;font-weight:bold;">PERIODO A VERIFICAR DE OBRA SOCIAL: 10 A&#209;OS</td>';
        html += '</tr>';
        html += '<tr>';
        html += '<td><strong>A&#209;O</strong><br>' + anioTexto + '</td>';
        html += '<td><strong>CUIT N&#176;</strong> ' + (this.cuit || '-') + ' &nbsp;&nbsp;&nbsp; <strong>FECHA LIQUIDACION:</strong> ' + (this.fechaLiquidacion || '') + '</td>';
        html += '</tr>';
        html += '<tr>';
        html += '<td><strong>EMPRESA</strong><br>' + (this.empresa || '') + '</td>';
        html += '<td><strong>DOMICILIO:</strong><br>' + (this.domicilio || '') + '</td>';
        html += '</tr>';
        html += '</table>';
        // Tabla 16 columnas
        html += '<table class="tabla-liq">';
        html += '<thead>';
        html += '<tr>';
        html += '<th rowspan="2">Periodo</th>';
        html += '<th rowspan="2">Cant.<br>Pers.</th>';
        html += '<th rowspan="2">REMUN.<br>TOTAL</th>';
        html += '<th rowspan="2">Imp.a<br>Pagar</th>';
        html += '<th rowspan="2">Aporte</th>';
        html += '<th rowspan="2">Contrib.</th>';
        html += '<th colspan="2" style="text-align:center;">Dep.Importes</th>';
        html += '<th rowspan="2">F.Venc.</th>';
        html += '<th rowspan="2">D.Mora</th>';
        html += '<th rowspan="2">DIF.PAGO</th>';
        html += '<th rowspan="2">INT.F.<br>TERM.</th>';
        html += '<th rowspan="2">AP.C.NO<br>DEP.</th>';
        html += '<th rowspan="2">SALDO<br>DEUD.</th>';
        html += '<th rowspan="2">ACT.<br>INT.</th>';
        html += '<th rowspan="2">TOTAL<br>ADEUD.</th>';
        html += '</tr>';
        html += '<tr>';
        html += '<th>IMPORTE</th>';
        html += '<th>FECHA</th>';
        html += '</tr>';
        html += '</thead>';
        html += '<tbody>';
        // Grand totals acumulados
        var grandRemuneracion = 0;
        var grandImporteAPagar = 0;
        var grandDiferenciaPago = 0;
        var grandIntereses = 0;
        var grandAportesNoDepo = 0;
        var grandSaldoDeudor = 0;
        var grandActualizacion = 0;
        var grandAdeudado = 0;
        for (var a = 0; a < aniosData.length; a++) {
            var liqAnio = aniosData[a];
            // Fila separadora de anio (solo si hay mas de 1 anio)
            if (aniosData.length > 1) {
                html += '<tr class="year-separator"><td colspan="16">A&#209;O ' + liqAnio.anio + '</td></tr>';
            }
            // Filas de periodos
            for (var i = 0; i < liqAnio.periodos.length; i++) {
                var p = liqAnio.periodos[i];
                html += '<tr>';
                html += '<td style="text-align:center;">' + p.periodo + '</td>';
                html += '<td style="text-align:center;">' + (p.cantidadPersonal || '') + '</td>';
                html += '<td class="money">' + this.formatCurrency(p.remuneracionTotal) + '</td>';
                html += '<td class="money">' + this.formatCurrency(p.importeAPagar) + '</td>';
                html += '<td class="money">' + this.formatCurrency(p.aporte) + '</td>';
                html += '<td class="money">' + this.formatCurrency(p.contribucion) + '</td>';
                html += '<td class="money">' + this.formatCurrency(p.detalleImporte) + '</td>';
                html += '<td style="border:1px solid #999;padding:3px 4px;text-align:center;font-size:9px;">' + (p.detalleFecha || '') + '</td>';
                html += '<td style="border:1px solid #999;padding:3px 4px;text-align:center;font-size:9px;">' + (p.fechaVencimiento || '') + '</td>';
                html += '<td style="border:1px solid #999;padding:3px 4px;text-align:center;">' + (p.diasMora || '') + '</td>';
                html += '<td class="money">' + this.formatCurrency(p.diferenciaPagoParcial) + '</td>';
                html += '<td class="money">' + this.formatCurrency(p.interesesPagoFueraTermino) + '</td>';
                html += '<td class="money">' + this.formatCurrency(p.aportesContrNoDepositadas) + '</td>';
                html += '<td class="money">' + this.formatCurrency(p.saldoDeudor) + '</td>';
                html += '<td class="money">' + this.formatCurrency(p.actualizacionIntereses) + '</td>';
                html += '<td class="money" style="font-weight:bold;">' + this.formatCurrency(p.totalAdeudadoPeriodo) + '</td>';
                html += '</tr>';
            }
            // Fila subtotal del anio (si hay mas de 1 anio, label es SUBTOTAL; si es 1 solo anio, es TOTAL)
            var subtotalLabel = aniosData.length > 1 ? 'SUBTOTAL ' + liqAnio.anio : 'TOTAL';
            html += '<tr style="background-color:#e8e8e8;font-weight:bold;">';
            html += '<td style="font-weight:bold;">' + subtotalLabel + '</td>';
            html += '<td></td>';
            html += '<td class="money">' + this.formatCurrency(liqAnio.totalRemuneracion) + '</td>';
            html += '<td class="money">' + this.formatCurrency(liqAnio.totalImporteAPagar) + '</td>';
            html += '<td class="money"></td>';
            html += '<td class="money"></td>';
            html += '<td class="money"></td>';
            html += '<td style="border:1px solid #999;padding:2px 3px;"></td>';
            html += '<td style="border:1px solid #999;padding:2px 3px;"></td>';
            html += '<td style="border:1px solid #999;padding:2px 3px;"></td>';
            html += '<td class="money">' + this.formatCurrency(liqAnio.totalDiferenciaPago) + '</td>';
            html += '<td class="money">' + this.formatCurrency(liqAnio.totalIntereses) + '</td>';
            html += '<td class="money">' + this.formatCurrency(liqAnio.totalAportesNoDepo) + '</td>';
            html += '<td class="money">' + this.formatCurrency(liqAnio.totalSaldoDeudor) + '</td>';
            html += '<td class="money">' + this.formatCurrency(liqAnio.totalActualizacion) + '</td>';
            html += '<td class="money" style="font-weight:bold;">' + this.formatCurrency(liqAnio.totalAdeudado) + '</td>';
            html += '</tr>';
            // Acumular grand totals
            grandRemuneracion += liqAnio.totalRemuneracion;
            grandImporteAPagar += liqAnio.totalImporteAPagar;
            grandDiferenciaPago += liqAnio.totalDiferenciaPago;
            grandIntereses += liqAnio.totalIntereses;
            grandAportesNoDepo += liqAnio.totalAportesNoDepo;
            grandSaldoDeudor += liqAnio.totalSaldoDeudor;
            grandActualizacion += liqAnio.totalActualizacion;
            grandAdeudado += liqAnio.totalAdeudado;
        }
        // Fila TOTAL GENERAL (solo si hay mas de 1 anio)
        if (aniosData.length > 1) {
            html += '<tr style="background-color:#c0c0c0;font-weight:bold;">';
            html += '<td style="font-weight:bold;">TOTAL GENERAL</td>';
            html += '<td></td>';
            html += '<td class="money">' + this.formatCurrency(this.r2(grandRemuneracion)) + '</td>';
            html += '<td class="money">' + this.formatCurrency(this.r2(grandImporteAPagar)) + '</td>';
            html += '<td class="money"></td>';
            html += '<td class="money"></td>';
            html += '<td class="money"></td>';
            html += '<td style="border:1px solid #999;padding:2px 3px;"></td>';
            html += '<td style="border:1px solid #999;padding:2px 3px;"></td>';
            html += '<td style="border:1px solid #999;padding:2px 3px;"></td>';
            html += '<td class="money">' + this.formatCurrency(this.r2(grandDiferenciaPago)) + '</td>';
            html += '<td class="money">' + this.formatCurrency(this.r2(grandIntereses)) + '</td>';
            html += '<td class="money">' + this.formatCurrency(this.r2(grandAportesNoDepo)) + '</td>';
            html += '<td class="money">' + this.formatCurrency(this.r2(grandSaldoDeudor)) + '</td>';
            html += '<td class="money">' + this.formatCurrency(this.r2(grandActualizacion)) + '</td>';
            html += '<td class="money" style="font-weight:bold;">' + this.formatCurrency(this.r2(grandAdeudado)) + '</td>';
            html += '</tr>';
        }
        html += '</tbody>';
        html += '</table>';
        // Observaciones
        html += '<div class="obs-box">';
        html += '<strong>OBSERVACIONES:</strong> ' + (this.observaciones || '');
        html += '</div>';
        // Firma
        html += '<div style="text-align:center;margin-top:15px;">';
        html += '<div style="width:200px;border-top:1px solid #000;margin:0 auto;"></div>';
        html += '<div style="font-size:9px;">FIRMA Y ACLARACION DEL INSPECTOR</div>';
        html += '</div>';
        html += '</div>'; // Fin page-tabla
        return html;
    };
    /**
     * Construye el HTML de la pagina portrait (resumen de deuda) para un anio
     */
    LiquidacionesComponent.prototype.construirResumenAnioHtml = function (liqAnio, logoTag) {
        var html = '<div class="page-resumen"><div class="resumen-content">';
        // Header institucional
        html += '<div style="text-align:center;margin-bottom:15px;">';
        html += '<div>' + logoTag + '</div>';
        html += '<strong>OBRA SOCIAL DE RECIBIDORES DE GRANOS Y ANEXOS</strong><br>';
        html += '<strong>RNOS N&#176; 118804</strong><br>';
        html += '<small>Av. Belgrano 510 - 5&#176; Piso - Buenos Aires C.P. 1092 - Tel/Fax: 011 - 4331-0865</small><br>';
        html += '<small>www.osrga.org.ar</small>';
        html += '</div>';
        // Datos del documento
        html += '<table style="margin-bottom:10px;">';
        html += '<tr>';
        html += '<td><strong>Fecha:</strong></td>';
        html += '<td>' + (this.fechaLiquidacion || '') + '</td>';
        html += '<td><strong>VENCIMIENTO - PAGO OBLIGACI&#211;N:</strong></td>';
        html += '<td>' + (this.vencimientoPagoObligacion || '') + '</td>';
        html += '</tr>';
        html += '<tr>';
        html += '<td><strong>Raz&#243;n Social:</strong></td>';
        html += '<td>' + (this.empresa || '') + '</td>';
        html += '<td><strong>CUIT:</strong></td>';
        html += '<td>' + (this.cuit || '') + '</td>';
        html += '</tr>';
        html += '<tr>';
        html += '<td><strong>Domicilio:</strong></td>';
        html += '<td colspan="3">' + (this.domicilio || '') + '</td>';
        html += '</tr>';
        html += '</table>';
        // Tabla de montos
        html += '<table class="resumen-montos">';
        html += '<tr><td>DIFERENCIA PAGO PARCIAL</td><td>$ ' + this.formatCurrency(this.r2(liqAnio.totalDiferenciaPago)) + '</td></tr>';
        html += '<tr><td>INTERESES POR PAGO FUERA DE TERMINO</td><td>$ ' + this.formatCurrency(liqAnio.totalIntereses) + '</td></tr>';
        html += '<tr><td>APORTES Y CONTR. NO DEPOSITADAS</td><td>$ ' + this.formatCurrency(this.r2(liqAnio.totalAportesNoDepo)) + '</td></tr>';
        html += '<tr><td>SALDO DEUDOR</td><td>$ ' + this.formatCurrency(this.r2(liqAnio.totalSaldoDeudor)) + '</td></tr>';
        html += '<tr><td>ACTUALIZACION DE INTERESES</td><td>$ ' + this.formatCurrency(liqAnio.totalActualizacion) + '</td></tr>';
        html += '<tr class="total-row"><td><strong>TOTAL ADEUDADO DEL PERIODO</strong></td><td><strong>$ ' + this.formatCurrency(liqAnio.totalAdeudado) + '</strong></td></tr>';
        html += '</table>';
        // Son pesos
        html += '<p><strong>SON PESOS:</strong> ' + (this.totalEnLetras || '') + '</p>';
        // Texto legal
        if (this.textoLegalActivo) {
            html += '<div style="font-size:10px;margin:10px 0;">';
            html += '<p>' + this.textoLegalP1Pre + this.diasPlazo + ' (' + (this.diasPlazoLetras || 'cinco') + ')' + this.textoLegalP1Post + '</p>';
            html += '<p>' + this.textoLegalP2Normal + '<strong>' + this.textoLegalP2Negrita + '</strong></p>';
            html += '</div>';
        }
        // Datos representante
        html += '<div style="font-size:10px;margin:10px 0;">';
        html += '<p>En la persona del Sr. ' + (this.representanteNombre || '_______________') + ' con domicilio legal en ' + (this.representanteDomicilio || '_______________') + '</p>';
        html += '<p>quien exhibi&#243; D.N.I. N&#176; ' + (this.representanteDNI || '_______________') + ' en su car&#225;cter de ' + (this.representanteCargo || '_______________') + ' de la empresa inspeccionada, firmante del Acta que se actualiza, se notifica de la conformaci&#243;n definitiva de las deudas, formando, la presente, parte integrante del instrumento mencionado.</p>';
        html += '</div>';
        // Firmas finales
        html += '<div class="firmas-container">';
        html += '<div class="firma-block"><div class="firma-line"></div><strong>Inspector</strong><br><small>Firma y Sello</small></div>';
        html += '<div class="firma-block"><div class="firma-line"></div><strong>Fecha de Notificaci&#243;n</strong></div>';
        html += '<div class="firma-block"><div class="firma-line"></div><strong>Responsable</strong><br><small>Firma y Sello</small></div>';
        html += '</div>';
        html += '</div></div>'; // Fin resumen-content + page-resumen
        return html;
    };
    /**
     * Construye un unico resumen de deuda con totales acumulados de todos los anios.
     * Reemplaza la generacion de un resumen por cada anio.
     */
    LiquidacionesComponent.prototype.construirResumenUnicoHtml = function (aniosData, logoTag) {
        // Sumar totales de todos los anios
        var grandAportesNoDepo = 0;
        var grandDiferenciaPago = 0;
        var grandIntereses = 0;
        var grandSaldoDeudor = 0;
        var grandActualizacion = 0;
        var grandAdeudado = 0;
        for (var i = 0; i < aniosData.length; i++) {
            grandAportesNoDepo += aniosData[i].totalAportesNoDepo;
            grandDiferenciaPago += aniosData[i].totalDiferenciaPago;
            grandIntereses += aniosData[i].totalIntereses;
            grandSaldoDeudor += aniosData[i].totalSaldoDeudor;
            grandActualizacion += aniosData[i].totalActualizacion;
            grandAdeudado += aniosData[i].totalAdeudado;
        }
        grandDiferenciaPago = this.r2(grandDiferenciaPago);
        grandAportesNoDepo = this.r2(grandAportesNoDepo);
        grandIntereses = this.r2(grandIntereses);
        grandSaldoDeudor = this.r2(grandSaldoDeudor);
        grandActualizacion = this.r2(grandActualizacion);
        grandAdeudado = this.r2(grandAdeudado);
        var html = '<div class="page-resumen"><div class="resumen-content">';
        // Header institucional
        html += '<div style="text-align:center;margin-bottom:15px;">';
        html += '<div>' + logoTag + '</div>';
        html += '<strong>OBRA SOCIAL DE RECIBIDORES DE GRANOS Y ANEXOS</strong><br>';
        html += '<strong>RNOS N&#176; 118804</strong><br>';
        html += '<small>Av. Belgrano 510 - 5&#176; Piso - Buenos Aires C.P. 1092 - Tel/Fax: 011 - 4331-0865</small><br>';
        html += '<small>www.osrga.org.ar</small>';
        html += '</div>';
        // Datos del documento
        html += '<table style="margin-bottom:10px;">';
        html += '<tr>';
        html += '<td><strong>Fecha:</strong></td>';
        html += '<td>' + (this.fechaLiquidacion || '') + '</td>';
        html += '<td><strong>VENCIMIENTO - PAGO OBLIGACI&#211;N:</strong></td>';
        html += '<td>' + (this.vencimientoPagoObligacion || '') + '</td>';
        html += '</tr>';
        html += '<tr>';
        html += '<td><strong>Raz&#243;n Social:</strong></td>';
        html += '<td>' + (this.empresa || '') + '</td>';
        html += '<td><strong>CUIT:</strong></td>';
        html += '<td>' + (this.cuit || '') + '</td>';
        html += '</tr>';
        html += '<tr>';
        html += '<td><strong>Domicilio:</strong></td>';
        html += '<td colspan="3">' + (this.domicilio || '') + '</td>';
        html += '</tr>';
        html += '</table>';
        // Tabla de montos con totales acumulados
        html += '<table class="resumen-montos">';
        html += '<tr><td>DIFERENCIA PAGO PARCIAL</td><td>$ ' + this.formatCurrency(grandDiferenciaPago) + '</td></tr>';
        html += '<tr><td>INTERESES POR PAGO FUERA DE TERMINO</td><td>$ ' + this.formatCurrency(grandIntereses) + '</td></tr>';
        html += '<tr><td>APORTES Y CONTR. NO DEPOSITADAS</td><td>$ ' + this.formatCurrency(grandAportesNoDepo) + '</td></tr>';
        html += '<tr><td>SALDO DEUDOR</td><td>$ ' + this.formatCurrency(grandSaldoDeudor) + '</td></tr>';
        html += '<tr><td>ACTUALIZACION DE INTERESES</td><td>$ ' + this.formatCurrency(grandActualizacion) + '</td></tr>';
        html += '<tr class="total-row"><td><strong>TOTAL ADEUDADO DEL PERIODO</strong></td><td><strong>$ ' + this.formatCurrency(grandAdeudado) + '</strong></td></tr>';
        html += '</table>';
        // Son pesos
        html += '<p><strong>SON PESOS:</strong> ' + (this.totalEnLetras || '') + '</p>';
        // Texto legal
        if (this.textoLegalActivo) {
            html += '<div style="font-size:10px;margin:10px 0;">';
            html += '<p>' + this.textoLegalP1Pre + this.diasPlazo + ' (' + (this.diasPlazoLetras || 'cinco') + ')' + this.textoLegalP1Post + '</p>';
            html += '<p>' + this.textoLegalP2Normal + '<strong>' + this.textoLegalP2Negrita + '</strong></p>';
            html += '</div>';
        }
        // Datos representante
        html += '<div style="font-size:10px;margin:10px 0;">';
        html += '<p>En la persona del Sr. ' + (this.representanteNombre || '_______________') + ' con domicilio legal en ' + (this.representanteDomicilio || '_______________') + '</p>';
        html += '<p>quien exhibi&#243; D.N.I. N&#176; ' + (this.representanteDNI || '_______________') + ' en su car&#225;cter de ' + (this.representanteCargo || '_______________') + ' de la empresa inspeccionada, firmante del Acta que se actualiza, se notifica de la conformaci&#243;n definitiva de las deudas, formando, la presente, parte integrante del instrumento mencionado.</p>';
        html += '</div>';
        // Firmas finales
        html += '<div class="firmas-container">';
        html += '<div class="firma-block"><div class="firma-line"></div><strong>Inspector</strong><br><small>Firma y Sello</small></div>';
        html += '<div class="firma-block"><div class="firma-line"></div><strong>Fecha de Notificaci&#243;n</strong></div>';
        html += '<div class="firma-block"><div class="firma-line"></div><strong>Responsable</strong><br><small>Firma y Sello</small></div>';
        html += '</div>';
        html += '</div></div>'; // Fin resumen-content + page-resumen
        return html;
    };
    /**
     * Construye pagina de resumen general para multi-anio (2+ anios)
     */
    LiquidacionesComponent.prototype.construirGrandTotalHtml = function (anios, logoTag) {
        var html = '<div class="page-resumen"><div class="resumen-content">';
        // Header
        html += '<div style="text-align:center;margin-bottom:15px;">';
        html += '<div>' + logoTag + '</div>';
        html += '<strong>OBRA SOCIAL DE RECIBIDORES DE GRANOS Y ANEXOS</strong><br>';
        html += '<strong>RNOS N&#176; 118804</strong>';
        html += '</div>';
        // Titulo
        html += '<h3 style="text-align:center;">RESUMEN GENERAL DE DEUDA</h3>';
        // Info empresa
        html += '<table style="margin-bottom:15px;">';
        html += '<tr><td><strong>CUIT:</strong></td><td>' + (this.cuit || '') + '</td></tr>';
        html += '<tr><td><strong>Empresa:</strong></td><td>' + (this.empresa || '') + '</td></tr>';
        html += '<tr><td><strong>Domicilio:</strong></td><td>' + (this.domicilio || '') + '</td></tr>';
        html += '<tr><td><strong>Fecha Liquidaci&#243;n:</strong></td><td>' + (this.fechaLiquidacion || '') + '</td></tr>';
        html += '</table>';
        // Tabla resumen por anio
        html += '<table class="resumen-montos">';
        html += '<tr style="background-color:#e8e8e8;font-weight:bold;">';
        html += '<td>A&#241;o</td>';
        html += '<td style="text-align:right;">Ap.Contr.No Dep.</td>';
        html += '<td style="text-align:right;">Intereses</td>';
        html += '<td style="text-align:right;">Total Adeudado</td>';
        html += '</tr>';
        var grandAportesNoDepo = 0;
        var grandActualizacion = 0;
        var grandAdeudado = 0;
        for (var i = 0; i < anios.length; i++) {
            var a = anios[i];
            grandAportesNoDepo += a.totalAportesNoDepo + a.totalDiferenciaPago;
            grandActualizacion += a.totalActualizacion;
            grandAdeudado += a.totalAdeudado;
            html += '<tr>';
            html += '<td>' + a.anio + '</td>';
            html += '<td style="text-align:right;">$ ' + this.formatCurrency(this.r2(a.totalAportesNoDepo + a.totalDiferenciaPago)) + '</td>';
            html += '<td style="text-align:right;">$ ' + this.formatCurrency(a.totalActualizacion) + '</td>';
            html += '<td style="text-align:right;">$ ' + this.formatCurrency(a.totalAdeudado) + '</td>';
            html += '</tr>';
        }
        html += '<tr class="total-row">';
        html += '<td><strong>GRAN TOTAL</strong></td>';
        html += '<td style="text-align:right;"><strong>$ ' + this.formatCurrency(grandAportesNoDepo) + '</strong></td>';
        html += '<td style="text-align:right;"><strong>$ ' + this.formatCurrency(grandActualizacion) + '</strong></td>';
        html += '<td style="text-align:right;"><strong>$ ' + this.formatCurrency(grandAdeudado) + '</strong></td>';
        html += '</tr>';
        html += '</table>';
        // Son pesos
        html += '<p style="margin-top:15px;"><strong>SON PESOS:</strong> ' + (this.totalEnLetras || '') + '</p>';
        html += '</div></div>'; // Fin resumen-content + page-resumen
        return html;
    };
    /**
     * Imprime la liquidacion completa usando un popup (Patron 2).
     * Soporta single-year y multi-year. Usa CSS named pages para
     * mezclar landscape (tabla) con portrait (resumen).
     */
    LiquidacionesComponent.prototype.imprimirPopup = function () {
        // Normalizar datos: si es single-year, envolver en array
        var aniosData;
        if (this.liquidacionesAnios.length > 0) {
            aniosData = this.liquidacionesAnios;
        }
        else {
            aniosData = [{
                    anio: this.anio,
                    periodos: this.periodos,
                    totalRemuneracion: this.totalRemuneracion,
                    totalImporteAPagar: this.totalImporteAPagar,
                    totalAporte: this.totalAporte,
                    totalContribucion: this.totalContribucion,
                    totalDiferenciaPago: this.totalDiferenciaPago,
                    totalIntereses: this.totalIntereses,
                    totalAportesNoDepo: this.totalAportesNoDepo,
                    totalSaldoDeudor: this.totalSaldoDeudor,
                    totalActualizacion: this.totalActualizacion,
                    totalAdeudado: this.totalAdeudado
                }];
        }
        // Preparar logo tag
        var logoTag = this.logoBase64
            ? '<img src="' + this.logoBase64 + '" class="logo-img">'
            : '<strong>OS.R.GA</strong>';
        // Construir body HTML: una acta por cada año con deuda (omitir años sin deuda)
        var bodyHtml = '';
        var aniosConDeuda = aniosData.filter(function (a) { return a.totalAdeudado > 0; });
        for (var i = 0; i < aniosConDeuda.length; i++) {
            bodyHtml += this.construirTablaAnioHtml(aniosConDeuda[i], logoTag);
        }
        // Un unico resumen de deuda con totales acumulados de los anios con deuda
        bodyHtml += this.construirResumenUnicoHtml(aniosConDeuda, logoTag);
        var fullHtml = '<html><head>'
            + '<title> </title>'
            + '<style>' + this.construirCssPopup() + '</style>'
            + '</head><body>'
            + bodyHtml
            + '<' + 'script>window.onload = function() { window.print(); }</' + 'script>'
            + '</body></html>';
        // Crear blob URL para que Chrome no bloquee la apertura
        var blob = new Blob([fullHtml], { type: 'text/html' });
        var blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        setTimeout(function () { URL.revokeObjectURL(blobUrl); }, 30000);
    };
    /**
     * Abre el modal para crear una empresa nueva
     */
    LiquidacionesComponent.prototype.abrirModalCrearEmpresa = function () {
        var _this = this;
        var dialogRef = this.dialog.open(CrearEmpresaDialogComponent, {
            width: '500px',
            maxWidth: '90vw',
            disableClose: false,
            panelClass: 'crear-empresa-dialog',
            data: { cuit: this.cuit }
        });
        dialogRef.afterClosed().subscribe(function (result) {
            if (result) {
                // Empresa creada exitosamente
                _this.cuit = result.cuit;
                _this.empresa = result.razonSocial;
                _this.domicilio = (result.calle || '') + ' ' + (result.puerta || '');
                _this.empresaNoRegistrada = false;
                // Buscar datos de la empresa
                _this.buscarEmpresa();
                _this.snackBar.open('Empresa creada. Buscando datos...', 'Cerrar', { duration: 3000 });
            }
        });
    };
    return LiquidacionesComponent;
}());
export { LiquidacionesComponent };
